module.exports = __webpack_public_path__ + "img/product1.4e9366ff.png";